import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-water-fall-details',
  templateUrl: './water-fall-details.component.html',
  styleUrls: ['./water-fall-details.component.scss']
})
export class WaterFallDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
